import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Summarized Contract Information", -1)
const _hoisted_3 = { class: "d-flex flex-column gap-4 mt-20" }
const _hoisted_4 = { class: "d-flex flex-column gap-20 sm-gap-10" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-md-end flex-md-row flex-column gap-20 sm-gap-10 w-100"
}
const _hoisted_6 = { class: "d-flex align-items-end gap-20 w-50 w-sm-100" }
const _hoisted_7 = { class: "custom-select links w-50 w-sm-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Employer(s): ", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-secondary-red"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-end gap-20 w-100"
}
const _hoisted_11 = { class: "d-flex align-items-end gap-20 w-100 flex-md-row flex-column" }
const _hoisted_12 = { class: "custom-select links" }
const _hoisted_13 = { class: "body-text" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "custom-select links" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Contract Type: ", -1)
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center gap-20 w-100 mt-10" }
const _hoisted_18 = { class: "d-flex justify-content-between gap-20" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  class: "small striped toggle no-underline mt-30",
  id: "table-contract-info"
}
const _hoisted_21 = { class: "large large_padding" }
const _hoisted_22 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, "Production", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, "Contract Type", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode("Contract Sub "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Type")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode("Contract Begin "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Date ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode("Contract End "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Date ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, [
  /*#__PURE__*/_createTextVNode("Rate Group "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Name")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "col-md-2" }, "Rate ", -1)
const _hoisted_30 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_31 = { class: "col-md-1" }
const _hoisted_32 = { class: "col-md-1" }
const _hoisted_33 = { class: "col-md-1" }
const _hoisted_34 = { class: "col-md-1" }
const _hoisted_35 = { class: "col-md-1" }
const _hoisted_36 = { class: "col-md-1" }
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "fw-bold" }
const _hoisted_39 = {
  key: 0,
  class: "divider mt-5 mb-5"
}
const _hoisted_40 = {
  key: 0,
  class: "hidden"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  style: {"background-color":"white","height":"130px"}
}, null, -1)
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      error: $setup.errors?.General
    }, null, 8, ["error"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: "This page allows you to look for specific CBA information based on different search parameters that are on file at the Fund Office.",
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }),
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($setup.isLocal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DateInput, {
                    label: "Work Period",
                    reset: $setup.reset,
                    "onUpdate:reset": _cache[0] || (_cache[0] = ($event: any) => (($setup.reset) = $event)),
                    modelValue: $setup.filters.WorkPeriod.StartDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.WorkPeriod.StartDate) = $event)),
                    isRequired: true,
                    error: $setup.errors['WorkPeriod.StartDate']
                  }, null, 8, ["reset", "modelValue", "error"]),
                  _createVNode(_component_DateInput, {
                    reset: $setup.reset,
                    "onUpdate:reset": _cache[2] || (_cache[2] = ($event: any) => (($setup.reset) = $event)),
                    modelValue: $setup.filters.WorkPeriod.EndDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.WorkPeriod.EndDate) = $event)),
                    error: $setup.errors['WorkPeriod.EndDate']
                  }, null, 8, ["reset", "modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Multiselect, {
                    modelValue: $setup.filters.Employers,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.Employers) = $event)),
                    options: $setup.data.employers,
                    placeholder: "Type to search",
                    multiple: true,
                    "hide-selected": true,
                    searchable: true,
                    "close-on-select": true,
                    onSelect: $setup.handleEmployerChange,
                    label: "Name",
                    "track-by": "ID",
                    onSearchChange: $setup.handleEmployersSearch,
                    onRemove: $setup.handleProductions,
                    loading: $setup.loading.employers
                  }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "onRemove", "loading"]),
                  ($setup.errors.Employers?.length)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString($setup.errors.Employers.join('. ')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_DateInput, {
                  reset: $setup.reset,
                  "onUpdate:reset": _cache[5] || (_cache[5] = ($event: any) => (($setup.reset) = $event)),
                  label: "Work Period Start",
                  modelValue: $setup.filters.WorkPeriod.StartDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filters.WorkPeriod.StartDate) = $event)),
                  isRequired: true,
                  error: $setup.errors['WorkPeriod.StartDate']
                }, null, 8, ["reset", "modelValue", "error"]),
                _createVNode(_component_DateInput, {
                  reset: $setup.reset,
                  "onUpdate:reset": _cache[7] || (_cache[7] = ($event: any) => (($setup.reset) = $event)),
                  label: "Work Period End",
                  modelValue: $setup.filters.WorkPeriod.EndDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.filters.WorkPeriod.EndDate) = $event)),
                  isRequired: true,
                  error: $setup.errors['WorkPeriod.EndDate']
                }, null, 8, ["reset", "modelValue", "error"])
              ])),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _createTextVNode(" Production(s) "),
                ($setup.hasEmployers)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " for selected Employer(s)"))
                  : _createCommentVNode("", true),
                _createTextVNode(": ")
              ]),
              _createVNode(_component_Multiselect, {
                modelValue: $setup.filters.Productions,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.filters.Productions) = $event)),
                options: $setup.data.productions,
                placeholder: "Type to search",
                multiple: true,
                "hide-selected": true,
                searchable: true,
                "close-on-select": true,
                onSelect: $setup.handleProductionChange,
                label: "Name",
                "track-by": "ID",
                onOpen: $setup.handleProductionsOpen,
                onSearchChange: $setup.handleProductionsSearch,
                loading: $setup.loading.productions
              }, null, 8, ["modelValue", "options", "onSelect", "onOpen", "onSearchChange", "loading"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Multiselect, {
                modelValue: $setup.filters.ContractTypes,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.filters.ContractTypes) = $event)),
                options: $setup.data.contractTypes,
                placeholder: "Type to search",
                multiple: true,
                "hide-selected": true,
                searchable: true,
                "close-on-select": true,
                label: "Name",
                "track-by": "ID",
                onSelect: $setup.handleContractChange,
                onSearchChange: $setup.handleContractSearch,
                onOpen: $setup.handleContractOpen,
                loading: $setup.loading.contractTypes
              }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "onOpen", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($setup.resetFilters && $setup.resetFilters(...args)), ["prevent"]))
              }, "Clear Filters"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["prevent"])),
                onKeydown: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["enter"]))
              }, _toDisplayString($setup.loadingSearch ? 'Searching...' : 'Apply Filters'), 33)
            ]),
            ($setup.contractInformation.length)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "iatse-icon-printer fs-xxl text-primary plan-modal sm-fs-xl",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.printList && $setup.printList(...args)))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!$setup.loadingSearch && $setup.contractInformation.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("thead", _hoisted_21, [
                _createElementVNode("tr", null, [
                  ($setup.isLocal)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_22, "Employer"))
                    : _createCommentVNode("", true),
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28,
                  _hoisted_29
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contractInformation, (entry, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass(["large", { 'page-break': (index + 1) % 26 === 0 }])
                    }, [
                      ($setup.isLocal)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(entry.Employer), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(entry.Production), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(entry.Contract), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(entry.ContractSubType), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(entry.ContractBeginDate), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(entry.ContractEndDate), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(entry.RateGroupName), 1),
                      _createElementVNode("td", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.Rate, (rate, key, mainIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex flex-column gap-2",
                            key: key
                          }, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(key), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rate, (value, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(value), 1))
                            }), 128)),
                            (mainIndex < Object.keys(entry.Rate).length - 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ], 2),
                    ((index + 1) % 26 === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_40, _hoisted_42))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}